import { EventInfoForm } from "./EventInfoForm";

export default EventInfoForm;
